import React from "react";

export function NoWrapLabel(props: {
  name: React.ReactNode;
  isRequired?: boolean;
  labelFor?: string;
}) {
  return (
    <label
      style={{ whiteSpace: "nowrap" }}
      className="label"
      htmlFor={props.labelFor}
    >
      {props.name}
      <span
        style={{
          color: "red",
          visibility: props.isRequired ? undefined : "hidden",
        }}
      >
        {" *"}
      </span>
    </label>
  );
}
